// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store/index'
import TIM from 'tim-js-sdk'
import TIMUploadPlugin from 'tim-upload-plugin'
// 表情组件
import VEmojiPicker from 'v-emoji-picker'
// vant组件库
import Vant from 'vant'
import 'vant/lib/index.css'
import https from './utils/https'
import '../src/theme/index'
import Header from './components/Header.vue'
import './router/routerControl'
import config from './config/index'
import setupVConsole from './utils/vconsole'
import directive from './directive/index'
directive(Vue)
setupVConsole()
Vue.use(Vant)
Vue.component('Header', Header)

Vue.prototype.$https = https

let options = {
  SDKAppID: config.SDKAppID
}

let tim = TIM.create(options)

tim.registerPlugin({'tim-upload-plugin': TIMUploadPlugin})
// 0 普通级别，日志量较多，接入时建议使用
// 1 release级别，SDK 输出关键信息，生产环境时建议使用
// 2 告警级别，SDK 只输出告警和错误级别的日志
// 3 错误级别，SDK 只输出错误级别的日志
// 4 无日志级别，SDK 将不打印任何日志
tim.setLogLevel(4)
Vue.prototype.tim = tim

Vue.use(ElementUI)
Vue.use(VEmojiPicker)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js